import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M16.07 16.07a.953.953 0 0 0 0-1.348l-2.697-2.698 2.697-2.697a.953.953 0 0 0-1.348-1.348l-2.697 2.697L9.328 7.98A.953.953 0 1 0 7.98 9.327l2.697 2.697-2.698 2.698a.953.953 0 0 0 1.348 1.348l2.698-2.697 2.698 2.698a.953.953 0 0 0 1.348 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }